// The inspector's lines for artifacts A10–A13 (§31) and the Legion Mandate
// (§33 T5): what each is doing now.

import type { GameState } from "src/engine/rules/commands";
import { stokePoints } from "src/engine/rules/campaign/stoke";
import { armyLogisticsFor } from "src/engine/rules/campaign/legion";
import { houseTicksAt } from "src/engine/rules/campaign/houseOfCards";
import {
  ENDURANCE_MONUMENT,
  FIEND_FOUNTAIN,
  HOUSE_OF_CARDS,
  LEGION_TOWER,
  PROPAGANDA_TOWER,
  type Structure
} from "src/engine/rules/industry/state";
import { ARTIFACTS_LATE } from "src/engine/rules/rules";
import type { BadgePip } from "./types";

export function lateArtifactPips(state: GameState, sq: number, structure: Structure, on: boolean): BadgePip[] {
  const tone: BadgePip["tone"] = on ? "working" : "waiting";
  switch (structure.kind) {
    case PROPAGANDA_TOWER:
      return [
        {
          glyph: "⚑",
          label: `+${stokePoints(state.industry, structure.owner)} Off-Turn Production — a tick per enemy faction each round`,
          tone
        }
      ];
    case HOUSE_OF_CARDS:
      return [
        {
          glyph: "♠",
          label:
            `${houseTicksAt(state, sq)} of ${ARTIFACTS_LATE.houseTicks} factory ticks to the next card reward; ` +
            `its Monarch's captures +${ARTIFACTS_LATE.brass}`,
          tone
        }
      ];
    case ENDURANCE_MONUMENT:
      return [
        {
          glyph: "⛉",
          label:
            `Obstructions +${ARTIFACTS_LATE.obstructionBulwark} HP, other buildings ` +
            `+${ARTIFACTS_LATE.structureBulwark}; its Monarch +${ARTIFACTS_LATE.defiance} armor`,
          tone
        }
      ];
    case FIEND_FOUNTAIN:
      return [{ glyph: "⛲", label: on ? "Factory Flow lifted — forge and move in one turn" : "Factory Flow binds", tone }];
    case LEGION_TOWER:
      return [
        {
          glyph: "⚔",
          label: `Army Logistics ${armyLogisticsFor(state.industry, structure.owner)} — Fodder Moves per Power Move`,
          tone
        }
      ];
    default:
      return [];
  }
}
